import React from 'react';

import { useObservability } from 'helpers/observability';
import { navTransactionLabel, useNavTransactions } from 'helpers/useNavTransactions';

import { MenuLinkItem } from '../components/MenuLinkItem';

interface MobileMenuAccountItemsProps {
  slug: string;
}

const isDashboardPath = (slug: string): boolean => {
  const normalizedSlug = slug.replace(/^\/+/, '');
  return normalizedSlug === 'dashboard' || normalizedSlug.startsWith('dashboard/');
};

/**
 * Mobile account items: Dashboard, active transactions, and Account settings.
 * Rendered inside the account section of {@link MobileMenuList}.
 */
export const MobileMenuAccountItemsV2: React.FC<MobileMenuAccountItemsProps> = ({ slug }) => {
  const { trackEvent } = useObservability();
  const transactions = useNavTransactions();

  return (
    <>
      <MenuLinkItem
        key="dashboard"
        href="/dashboard"
        name="Dashboard"
        analyticsName="cosmos-mobile-nav-dashboard"
        isActive={isDashboardPath(slug)}
        onPress={() =>
          trackEvent('cta-click', 'dashboard-link', undefined, {
            categoryOverride: 'homepage',
          })
        }
      />
      {transactions.map((transaction) => (
        <MenuLinkItem
          key={transaction.id}
          href={transaction.href}
          name={navTransactionLabel(transaction)}
          analyticsName={`cosmos-mobile-nav-${transaction.type}`}
          isActive={false}
        />
      ))}
      <MenuLinkItem
        key="account"
        href="/account"
        name="Account settings"
        analyticsName=""
        isActive={slug === '/account'}
        isLast
        onPress={() =>
          trackEvent('cta-click', 'account-link', undefined, { categoryOverride: 'homepage' })
        }
      />
    </>
  );
};
